import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onOutsideClick", "visible"];
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import styles from './withPopoverOutsideClickHandler.module.scss';
var POPOVER_CONTAINER_ID = 'popupContainerId';
var getPopoverContainer = function getPopoverContainer() {
  var elemToMount = document.getElementById(POPOVER_CONTAINER_ID);
  if (elemToMount) return elemToMount;
  var div = document.createElement('div');
  div.id = POPOVER_CONTAINER_ID;
  div.className = styles.popover;
  document.body.appendChild(div);
  return div;
};
function withPopoverOutsideClickHandler(WrappedComponent) {
  var Component = function Component(_ref) {
    var onOutsideClick = _ref.onOutsideClick,
      visible = _ref.visible,
      restProps = _objectWithoutProperties(_ref, _excluded);
    var handleAndCheckMaskClick = useCallback(function (event) {
      var target = event.target;
      if (target.className !== 'ant-popover-mask') return null;
      return onOutsideClick();
    }, [onOutsideClick]);
    useEffect(function () {
      if (visible) {
        document.addEventListener('mousedown', handleAndCheckMaskClick);
      }
      return function () {
        document.removeEventListener('mousedown', handleAndCheckMaskClick);
      };
    }, [visible, handleAndCheckMaskClick]);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
      visible: visible,
      mask: true,
      maskClosable: false,
      getPopupContainer: getPopoverContainer
    }));
  };
  Component.propTypes = {
    onOutsideClick: PropTypes.func,
    visible: PropTypes.bool
  };
  Component.defaultProps = {
    onOutsideClick: _noop,
    visible: false
  };
  return Component;
}
export default withPopoverOutsideClickHandler;